<template>
    <div class="form-field">
        <label :for="id"
            >{{ label }} <span v-if="required" class="required">*</span></label
        >
        <input
            v-model="value"
            name="text"
            type="text"
            placeholder="Your answer"
            :disabled="is_not_applicable"
        />
        <span class="error" v-if="error">{{ error }}</span>
        <div class="form-field--not-applicable" v-if="not_applicable">
            <div class="checkbox">
                <div class="form-field checkbox-wrap">
                    <input
                        type="checkbox"
                        v-model="is_not_applicable"
                        :id="`${id}_not_applicable`"
                        :name="`${name}_not_applicable`"
                        @change="onChangeIsNotApplicable"
                    />
                    <label :for="`${id}_not_applicable`">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Not applicable
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "URLInput",
    data() {
        return {
            value: "",
            is_not_applicable: false,
        };
    },
    mounted() {
        if (this.defaultValue) {
            this.value = this.defaultValue.value;
            this.is_not_applicable = this.defaultValue.not_applicable;
        }
    },
    props: [
        "id",
        "label",
        "name",
        "required",
        "setHasErrors",
        "defaultValue",
        "onChange",
        "error",
        "not_applicable",
    ],
    watch: {
        value: function (val) {
            this.onChange(this.name, {
                value: this.value,
                not_applicable: this.is_not_applicable,
            });
        },
        is_not_applicable: function (val) {
            this.onChange(this.name, {
                value: "",
                not_applicable: this.is_not_applicable,
            });
        },
    },
    methods: {
        onChangeIsNotApplicable(e) {
            if (e.target.checked) {
                this.is_not_applicable = true;
                this.onChange(this.name, {
                    value: "",
                    not_applicable: this.is_not_applicable,
                });

                this.value = "";
            } else {
                this.is_not_applicable = false;
            }
        },
    },
};
</script>
